import {BaseCriteriaModel} from '../base-criteria.model';
import {Optional} from 'typescript-optional';

export class AppletLoginSubjectLinkQueryCriteriaClass extends BaseCriteriaModel {
  link_type?: Optional<string> = Optional.empty();
  applet_hdr_guid?: Optional<string> = Optional.empty();
  app_login_guid?: Optional<string> = Optional.empty();
  tenant_guid?: Optional<string> = Optional.empty();
}

export class AppletLoginSubjectLinkCriteriaModelQuery {
  query = '';

  constructor(appletLoginSubjectLinkCriteriaModel: AppletLoginSubjectLinkQueryCriteriaClass) {

    if (!appletLoginSubjectLinkCriteriaModel) {
      return;
    }

    this.query += appletLoginSubjectLinkCriteriaModel.link_type.filter(x => x !== '').map(x => '&link_type=' + x).orElse('');
    this.query += appletLoginSubjectLinkCriteriaModel.applet_hdr_guid.filter(x => x !== '').map(x => '&applet_hdr_guid=' + x).orElse('');
    this.query += appletLoginSubjectLinkCriteriaModel.app_login_guid.filter(x => x !== '').map(x => '&app_login_guid=' + x).orElse('');
    this.query += appletLoginSubjectLinkCriteriaModel.tenant_guid.filter(x => x !== '').map(x => '&tenant_guid=' + x).orElse('');

    this.query += '&status=' + appletLoginSubjectLinkCriteriaModel.status;
    this.query += '&orderBy=' + appletLoginSubjectLinkCriteriaModel.orderBy;
    this.query += '&order=' + appletLoginSubjectLinkCriteriaModel.order;
    this.query += '&offset=' + appletLoginSubjectLinkCriteriaModel.offset + '&limit=' + appletLoginSubjectLinkCriteriaModel.limit;
  }
}
